// extracted by mini-css-extract-plugin
export default {"heading":"DuyurularContainer_heading__Ob+Kd","banner":"DuyurularContainer_banner__lHCvC"};